export const ProfileTypeOf = "USER_PROFILE"
